import { ECar } from "./ecar";
import { ECarType } from "./ecar-type";
import { TripPoint } from "./trip";
import { UserProfile } from "./user-profile";

export class User {
  Profile!: UserProfile;
  Ecars: ECar[] = [];
  /** Trip history per car, keyed by car id. */
  HistoryList: Record<string, any> = {};
  TipList: TripPoint[] = [];
  TrialUsed: boolean = false;

  public getSelectedCar(): ECarType | undefined {
    return this.getSelectedECar()?.ECarType ?? undefined;
  }

  public getSelectedUserCar(): ECar {
    return this.getSelectedECar()!;
  }

  public getCarById(userVehicleID: number): ECar | undefined {
    return this.Ecars.find((el => { return el.userVehicleID == userVehicleID }));
  }

  public getCarNameById(userVehicleID: number): string | null {
    const userVehicle = this.getCarById(userVehicleID);
    if (userVehicle == undefined) {
      return null;
    }
    else if (userVehicle.name == "") {
      return userVehicle.ECarType?.Name ?? null;
    }
    else {
      return userVehicle.name;
    }
  }

  private getSelectedECar(): ECar | undefined {
    return this.Ecars.find((el => { return el.selected }));
  }
}
